<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
    data-buttons-class="outline-primary"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

export default {
  components: {
    BootstrapTable
  },
  props: [
    'id',
  ],
  data () {
    return {
      columns: [
        {
          field: 'content',
          title: 'Submission',
          formatter: function(value, row, index){
            var submission = JSON.parse(value);
            var output='';
            submission.forEach(function(v){ output += v.label+': '+v.value+'<br />'; });
            return output;
          }
        },
        {
          field: 'created_at',
          title: 'Date Time',
          sortable: true,
          width:200,
          formatter: function(value, row, index){
            
            if(value !== null){

              value = new Date( value.replace(/-/g, "/") + ' UTC');

              value = value.getDate() + '/' + (value.getMonth()+1) + '/' + value.getFullYear() + ' ' + value.getHours() + ':' + (value.getMinutes()<10?'0':'') + value.getMinutes();
            }

            return value;
          }
        },
      ],
      data: '/form/results/'+this.id+'/data',
      options: {
        search: true,
      }
    }
  }
}




</script>